import { useState } from "react";
import { LogoMark } from "./Logo";

export default function ScreenshotFrame({
  src,
  label,
  ratio = "16 / 10",
  alt = "",
  className = "",
  imgClassName = "",
}) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(!src);
  return (
    <div
      className={`relative w-full overflow-hidden rounded-xl border border-line bg-subtle ${className}`}
      style={{ aspectRatio: ratio }}
    >
      {!failed && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className={`absolute inset-0 h-full w-full object-cover object-top transition-opacity duration-500 ${
            loaded ? "opacity-100" : "opacity-0"
          } ${imgClassName}`}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      )}
      {!loaded && (
        <div
          className="frame-placeholder absolute inset-0 flex flex-col items-center justify-center gap-3"
          data-testid="screenshot-placeholder"
        >
          <LogoMark size={28} className="opacity-50" />
          <span className="px-6 text-center text-[11px] font-medium uppercase tracking-[0.14em] text-dim">
            {label}
          </span>
        </div>
      )}
    </div>
  );
}
